import {
  VuexModule,
  Module,
  Mutation,
} from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class Snackbar extends VuexModule {
  public message: string = '';

  public error: boolean = false;

  public warning: boolean = false;

  @Mutation
  showNotification(payload: { message: string; error: boolean; warning?: boolean }) {
    this.message = payload.message;
    this.error = payload.error;
    this.warning = payload.warning || false;
  }
}
